import createQuery from './graphql-query-creator'
import makeGraphqlRequest from './../../../../lib/graphql-requestor'

const fetchData = async (mxfReleaseId, position) => {
  const hasCoordinates = position.latitude && position.longitude
  if (!mxfReleaseId || (!hasCoordinates && !position.postcode)) return null
  const vars = { ...position, mxfReleaseId }
  const query = createQuery(mxfReleaseId, position)
  const data = await makeGraphqlRequest(query, vars)
  if (data) {
    return {
      showtimes: data && data.showtimes && data.showtimes.showtimes
    }
  }
  return { showtimes: [] }
}

module.exports = fetchData
